import { z } from "zod"

export const scannedCodeSchema = z.object({
  version: z.number(),
  eventType: z.string(),
  refId: z.string(),
})

export type ScannedCodeSchemaType = z.infer<typeof scannedCodeSchema>
